<button class="offers-table-header-cell"
        (click)="updateSort()"
      [ngClass]="{'offers-table-header-cell--sort-active': sortActive}">
  <div class="offers-table-header-cell__label">
    {{ config.caption | translate }}
  </div>
  <span class="offers-table-header-cell__sort-icon">
    <img *ngIf="sortActive" [src]="sortActiveIcon" alt="">
    <img *ngIf="!sortActive" [src]="sortInactiveIcon" alt="">
  </span>
</button>
